import { useState, useEffect } from 'react';
import { TODAY } from '../lib/dateState.js';
import { pushToast } from '../lib/helpers.js';
import { searchRealUsers, createFutureMessage, fetchMySentFutureMessages, fetchDeliveredFutureMessages } from '../lib/api.js';
import { Av, Btn, Back } from '../components/Basic.jsx';
import { t as tr, LOCALE } from '../lib/i18n.js';
export function OncerFutureView({t,st,dispatch,go,userId}){
  const [tab,setTab]=useState("scrivi");
  const [content,setContent]=useState("");
  const [recipientType,setRecipientType]=useState("self");
  const [recipientLabel,setRecipientLabel]=useState("");
  const [friendQuery,setFriendQuery]=useState("");
  const [friendResults,setFriendResults]=useState([]);
  const [selectedFriend,setSelectedFriend]=useState(null);
  const [unlockPreset,setUnlockPreset]=useState("1y");
  const [customDate,setCustomDate]=useState("");
  const [sending,setSending]=useState(false);
  const [sent,setSent]=useState([]);
  const [delivered,setDelivered]=useState([]);
  const [loading,setLoading]=useState(false);
  useEffect(()=>{
    if(!friendQuery.trim()){ setFriendResults([]); return; }
    let active=true;
    const timer=setTimeout(async()=>{
      const results=await searchRealUsers(friendQuery,userId);
      if(active) setFriendResults(results);
    },350);
    return ()=>{ active=false; clearTimeout(timer); };
  },[friendQuery,userId]);
  const loadMessages=async()=>{
    if(!userId) return;
    setLoading(true);
    const [s,d]=await Promise.all([fetchMySentFutureMessages(userId),fetchDeliveredFutureMessages(userId)]);
    setSent(s); setDelivered(d);
    setLoading(false);
  };
  useEffect(()=>{ if(tab==="ricevuti") loadMessages(); },[tab]);
  const unlockDateValue=()=>{
    if(unlockPreset==="custom") return customDate;
    const d=new Date(TODAY);
    if(unlockPreset==="1y") d.setFullYear(d.getFullYear()+1);
    else if(unlockPreset==="6m") d.setMonth(d.getMonth()+6);
    else if(unlockPreset==="nextnewyear") { d.setFullYear(d.getFullYear()+1); d.setMonth(0); d.setDate(1); }
    return d.toISOString().slice(0,10);
  };
  const canSend=content.trim().length>0 && (recipientType!=="friend"||selectedFriend) && (unlockPreset!=="custom"||customDate);
  return(
    <div className="screen fade" style={{background:t.bg}}>
      <div style={{padding:"14px 14px 11px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:`1px solid ${t.ac}18`,flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:11}}><Back fn={()=>go("profile")} t={t}/><span style={{fontSize:16,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>⏳ Oncer Future</span></div>
      </div>
      <div style={{display:"flex",gap:8,padding:"11px 13px 0"}}>
        {[{id:"scrivi",label:tr("of_tab_write")},{id:"ricevuti",label:tr("of_tab_received")}].map(tb=>(
          <div key={tb.id} onClick={()=>setTab(tb.id)} style={{flex:1,textAlign:"center",padding:"9px",borderRadius:11,cursor:"pointer",background:tab===tb.id?t.pill:t.card,color:tab===tb.id?"#fff":t.soft,fontSize:12.5,fontFamily:"Inter,sans-serif",fontWeight:700}}>{tb.label}</div>
        ))}
      </div>
      <div style={{padding:"14px 13px 30px",flex:1,overflowY:"auto"}}>
        {tab==="scrivi"&&(
          <>
            <div style={{fontSize:12,color:t.soft,fontFamily:"Inter,sans-serif",lineHeight:1.6,marginBottom:14}}>{tr("of_write_intro")}</div>
            <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1px",textTransform:"uppercase",marginBottom:8}}>{tr("of_recipient_label")}</div>
            <div style={{display:"flex",gap:7,marginBottom:14}}>
              {[{id:"self",label:tr("of_recipient_self")},{id:"friend",label:tr("of_recipient_friend")},{id:"family",label:tr("of_recipient_family")}].map(r=>(
                <div key={r.id} onClick={()=>{setRecipientType(r.id);setSelectedFriend(null);}} style={{flex:1,textAlign:"center",padding:"9px 4px",borderRadius:11,cursor:"pointer",background:recipientType===r.id?t.pill:t.card,color:recipientType===r.id?"#fff":t.soft,fontSize:11.5,fontFamily:"Inter,sans-serif",fontWeight:700,border:recipientType===r.id?"none":`1px solid ${t.bord}`}}>{r.label}</div>
              ))}
            </div>
            {recipientType==="friend"&&(
              <div style={{marginBottom:14}}>
                {selectedFriend?(
                  <div style={{display:"flex",alignItems:"center",gap:9,background:t.card,borderRadius:11,padding:"9px 12px",border:`1px solid ${t.bord}`}}>
                    <Av u={selectedFriend.username} tid={selectedFriend.theme} sz={28} photo={selectedFriend.avatar_url}/>
                    <span style={{flex:1,fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:600,color:t.tx}}>@{selectedFriend.username}</span>
                    <span onClick={()=>setSelectedFriend(null)} style={{fontSize:12,color:t.soft,cursor:"pointer"}}>✕</span>
                  </div>
                ):(
                  <>
                    <input value={friendQuery} onChange={e=>setFriendQuery(e.target.value)} placeholder={tr("micro_search_username")} autoCapitalize="none" style={{width:"100%",boxSizing:"border-box",border:`1px solid ${t.bord}`,background:t.card,borderRadius:11,padding:"10px 13px",fontSize:16,fontFamily:"Inter,sans-serif",color:t.tx}}/>
                    {friendResults.map(u=>(
                      <div key={u.id} onClick={()=>{setSelectedFriend(u);setFriendQuery("");}} style={{display:"flex",alignItems:"center",gap:9,padding:"8px 6px",cursor:"pointer"}}>
                        <Av u={u.username} tid={u.theme} sz={28} photo={u.avatar_url}/>
                        <span style={{fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:600,color:t.tx}}>@{u.username}</span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
            {recipientType==="family"&&(
              <input value={recipientLabel} onChange={e=>setRecipientLabel(e.target.value)} placeholder={tr("of_family_placeholder")} style={{width:"100%",boxSizing:"border-box",border:`1px solid ${t.bord}`,background:t.card,borderRadius:11,padding:"10px 13px",fontSize:16,fontFamily:"Inter,sans-serif",color:t.tx,marginBottom:14}}/>
            )}
            <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1px",textTransform:"uppercase",marginBottom:8}}>{tr("of_unlock_when_label")}</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:7,marginBottom:14}}>
              {[{id:"6m",label:tr("of_unlock_6m")},{id:"1y",label:tr("of_unlock_1y")},{id:"nextnewyear",label:tr("of_unlock_nextnewyear")},{id:"custom",label:tr("of_unlock_custom")}].map(o=>(
                <div key={o.id} onClick={()=>setUnlockPreset(o.id)} style={{padding:"8px 13px",borderRadius:20,cursor:"pointer",background:unlockPreset===o.id?t.pill:t.card,color:unlockPreset===o.id?"#fff":t.soft,fontSize:11.5,fontFamily:"Inter,sans-serif",fontWeight:700,border:unlockPreset===o.id?"none":`1px solid ${t.bord}`}}>{o.label}</div>
              ))}
            </div>
            {unlockPreset==="custom"&&<input type="date" value={customDate} onChange={e=>setCustomDate(e.target.value)} min={new Date(TODAY.getTime()+86400000).toISOString().slice(0,10)} style={{width:"100%",boxSizing:"border-box",border:`1px solid ${t.bord}`,background:t.card,borderRadius:11,padding:"10px 13px",fontSize:16,fontFamily:"Inter,sans-serif",color:t.tx,marginBottom:14}}/>}
            <textarea value={content} onChange={e=>setContent(e.target.value)} placeholder={tr("of_content_placeholder")} rows={7} maxLength={2000} style={{width:"100%",boxSizing:"border-box",border:`1px solid ${t.bord}`,background:t.card,borderRadius:14,padding:"13px",fontSize:16,fontFamily:"Inter,sans-serif",color:t.tx,resize:"none",marginBottom:16}}/>
            <Btn full fn={async()=>{
              if(!canSend||sending||!userId)return;
              setSending(true);
              const ok=await createFutureMessage(userId,{
                toUserId:recipientType==="friend"?selectedFriend.id:null,
                recipientType,recipientLabel:recipientType==="family"?recipientLabel.trim():null,
                content:content.trim(),unlockDate:unlockDateValue(),
              });
              setSending(false);
              if(ok){ setContent("");setSelectedFriend(null);setRecipientLabel("");setUnlockPreset("1y");setCustomDate(""); setTab("ricevuti"); }
              else pushToast(dispatch,tr("of_toast_send_failed"));
            }} style={{background:canSend?"linear-gradient(135deg,#FF2D6B,#7B2FFF)":"rgba(128,128,128,.2)",color:"#fff",padding:"14px",borderRadius:40,fontSize:14,fontWeight:700,fontFamily:"Inter,sans-serif",textAlign:"center",opacity:canSend?(sending?.7:1):.5}}>{sending?tr("of_sending"):tr("of_send_btn")}</Btn>
          </>
        )}
        {tab==="ricevuti"&&(
          <>
            {loading&&<div style={{textAlign:"center",padding:"20px",color:t.soft,fontFamily:"Inter,sans-serif",fontSize:12}}>{tr("disc_loading")}</div>}
            {!loading&&delivered.length>0&&<>
              <div style={{fontSize:10,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:10}}>{tr("of_unlocked_label")}</div>
              {delivered.map(m=>(
                <div key={m.id} style={{background:t.card,borderRadius:14,padding:"14px",border:`1px solid ${t.bord}`,marginBottom:10}}>
                  <div style={{fontSize:10,color:t.ac,fontFamily:"Inter,sans-serif",fontWeight:700,marginBottom:6}}>
                    {m.from_user_id===userId?tr("of_written_by_you"):tr("of_from_user",{username:m.from_username})} · {new Date(m.unlock_date).toLocaleDateString(LOCALE,{day:"numeric",month:"long",year:"numeric"})}
                  </div>
                  <div style={{fontSize:13,color:t.tx,fontFamily:"Inter,sans-serif",lineHeight:1.6,whiteSpace:"pre-wrap"}}>{m.content}</div>
                </div>
              ))}
            </>}
            {!loading&&sent.filter(m=>new Date(m.unlock_date)>TODAY).length>0&&<>
              <div style={{fontSize:10,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:10,marginTop:18}}>{tr("of_in_transit_label")}</div>
              {sent.filter(m=>new Date(m.unlock_date)>TODAY).map(m=>(
                <div key={m.id} style={{background:t.card,borderRadius:14,padding:"14px",border:`1px dashed ${t.bord}`,marginBottom:10,opacity:.7}}>
                  <div style={{fontSize:22,marginBottom:6}}>🔒</div>
                  <div style={{fontSize:12,color:t.soft,fontFamily:"Inter,sans-serif"}}>{tr("of_unlocks_on",{date:new Date(m.unlock_date).toLocaleDateString(LOCALE,{day:"numeric",month:"long",year:"numeric"})})}</div>
                </div>
              ))}
            </>}
            {!loading&&delivered.length===0&&sent.length===0&&<div style={{textAlign:"center",padding:"30px 20px",color:t.soft,fontFamily:"Inter,sans-serif",fontSize:12}}>{tr("of_empty_state")}</div>}
          </>
        )}
      </div>
    </div>
  );
}
